import type { SetupState } from '../types/setup';

export const mockBuckleArrestorSetup: SetupState = {
  numberOfPipeSizes: 2,
  pipeSizes: [
    {
      size: '12.75',
      wallThickness: '0.5',
      buckleArrestors: '2',
      numberOfPipes: '10',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '120',
      manufacturer: 'Manufacturer A'
    },
    {
      size: '16.0',
      wallThickness: '0.75',
      buckleArrestors: '2',
      numberOfPipes: '8',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '96',
      manufacturer: 'Manufacturer B'
    }
  ],
  manufacturers: ['Manufacturer A', 'Manufacturer B', 'Manufacturer C'],
  isAddingManufacturer: false,
  newManufacturer: '',
  isSaving: false
};

export const mockPipeInPipeSetup: SetupState = {
  numberOfPipeSizes: 1,
  pipeSizes: [
    {
      size: '14.0',
      wallThickness: '0.625',
      buckleArrestors: '0',
      numberOfPipes: '12',
      pipeLength: '12.5',
      numberOfForges: '0',
      outputAssemblyLength: '150',
      manufacturer: 'Manufacturer A'
    }
  ],
  manufacturers: ['Manufacturer A', 'Manufacturer B', 'Manufacturer C'],
  isAddingManufacturer: false,
  newManufacturer: '',
  isSaving: false
}; 

export const mockBulkHeadSetup: SetupState = {
  numberOfPipeSizes: 1,
  pipeSizes: [
    {
      size: '14.0',
      wallThickness: '0.625',
      buckleArrestors: '0',
      numberOfPipes: '12',
      pipeLength: '12.5',
      numberOfForges: '0',
      outputAssemblyLength: '150',
      manufacturer: 'Manufacturer A'
    }
  ],
  manufacturers: ['Manufacturer A', 'Manufacturer B', 'Manufacturer C'],
  isAddingManufacturer: false,
  newManufacturer: '',
  isSaving: false
}; 